import {configureStore} from "@reduxjs/toolkit";
import userReducer from "./slices/UserSlice";
import breadcrumbsReducer from "./slices/BreadcrumbSlice";
import previewProductReducer from "./slices/PreviewProductSlice";
import productItemSliceReducer from "./slices/ProductReducerSlice"
import catalogProductsSliceReducer from "./slices/CatalogProductsReducerSlice"
import {thunk} from "redux-thunk";
import pagePaginationReducer from "./slices/PagePaginagionSlice";
import ordersReducer from "./slices/OrdersReducerSlice";
import orderReducer from "./slices/OrderReducerSlice";
import activeCartReducer from "./slices/ActiveCartReducerSlice";
import finTermsReducer from "./slices/FinTermsSlice";
import newReturnReducer from "./slices/NewReturnSlice";
import newWarrantyReducer from "./slices/NewWarrantySlice";
import returnsReducer from "./slices/ReturnsReducerSlice";
import returnReducer from "./slices/ReturnReducerSlice";
import warrantyRequestsReducer from "./slices/WarrantyRequestsReducerSlice";
import warrantyRequestReducer from "./slices/WarrantyRequestReducerSlice";
import creditLimitReducer from "./slices/CreditLimitRedicerSlice";
import creditLimitsReducer from "./slices/CreditLimitsReducerSlice";
import reservationLinesReducer from "./slices/ReservationLinesReducerSlice";
import hierarchyCategoryReducer from "./slices/MenuCategoriesSlice"
import orderShippingReducer from "./slices/OrderShippingSlice";
import reserveMutexReducer from "./slices/ReserveMutexSlice";
import reservationAllowanceReducer from "./slices/ReservationAllowanceSlice";

export const store = configureStore({
    reducer: {
        user: userReducer,
        breadcrumb: breadcrumbsReducer,
        page: pagePaginationReducer,
        product: productItemSliceReducer,
        orders: ordersReducer,
        reservationLines: reservationLinesReducer,
        order: orderReducer,
        activeCart: activeCartReducer,
        catalogProducts: catalogProductsSliceReducer,
        previewProduct: previewProductReducer,
        finTerms: finTermsReducer,
        newReturn: newReturnReducer,
        newWarranty:newWarrantyReducer,
        warrantyRequests: warrantyRequestsReducer,
        returns: returnsReducer,
        return: returnReducer,
        warrantyRequest: warrantyRequestReducer,
        creditLimits: creditLimitsReducer,
        creditLimit: creditLimitReducer,
        hierarchyCategory: hierarchyCategoryReducer,
        orderShipping: orderShippingReducer,
        reserveMutex: reserveMutexReducer,
        reservationAllowance: reservationAllowanceReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunk)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
